import { React, useEffect, useState } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  createBanner,
  getABanner,
  resetState,
  updateABanner,
} from "../features/banner/bannerSlice";
import Dropzone from "react-dropzone";
import { resolveMediaUrl } from "../utils/mediaUrl";

let schema = yup.object().shape({
  banner_title: yup.string().required("Banner Name is Required"),
  banner_image: yup.mixed().required("Banner Image is Required"),
});


const Addbanner = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const getbannerId = location.pathname.split("/")[3];
  const navigate = useNavigate();
  const bannerName = useSelector((state) => state.banner.bannerName);
  const bannerImage = useSelector((state) => state.banner.bannerImage);
  const {
    isSuccess,
    isError,
    isLoading,
    createdBanner,
    updatedBanner,
  } = useSelector((state) => state.banner);


  // const [img, setImg] = useState([]);
  const [img, setImg] = useState(null);

  useEffect(() => {
    if (getbannerId !== undefined) {
      dispatch(getABanner(getbannerId));
    } else {
      dispatch(resetState());
    }
  }, [getbannerId, dispatch]);

  useEffect(() => {
    if (isSuccess && createdBanner) {
      toast.success("Banner Added Successfully!");
      navigate("/admin/list-banner");
      dispatch(resetState());
    }
    if (isSuccess && updatedBanner) {
      toast.success("Banner Updated Successfully!");
      navigate("/admin/list-banner");
      dispatch(resetState());
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading, createdBanner, updatedBanner, navigate, dispatch]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      banner_title: bannerName || "",
      banner_image: bannerImage || "", // Preserve existing image
    },
    validationSchema: schema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("banner_title", values.banner_title);

      console.log(img);
      // Only append a new image if the user selected one
      if (img instanceof File) {
        formData.append("banner_image", img);
      } else if (bannerImage && typeof bannerImage === "string") {
        formData.append("banner_image", bannerImage); // Keep existing image
      } else {
        // If no image is available, send an empty value (optional)
        formData.append("banner_image", "");
      }

      if (getbannerId !== undefined) {
        const data = { id: getbannerId, bannerData: formData };
        dispatch(updateABanner(data));
      } else {
        dispatch(createBanner(formData));
        formik.resetForm();
      }
    },
  });

  return (
    <div>
      <h3 className="mb-4 title">
        {getbannerId !== undefined ? "Edit" : "Add"} Banner
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <div>
            <label className="form-label" htmlFor="banner_title">
              Banner Name <span className="text-danger">*</span>
            </label>
            <CustomInput
              type="text"
              label="Enter Product Banner"
              onChng={formik.handleChange("banner_title")}
              onBlr={formik.handleBlur("banner_title")}
              val={formik.values.banner_title}
              id="banner_title"
            />
            <div className="error">
              {formik.touched.banner_title && formik.errors.banner_title}
            </div>
          </div>

          <div>
            <label className="form-label" htmlFor="banner_image">
              Banner Image
            </label>

            <div className="bg-white border-1 p-5 text-center mt-1">
              <Dropzone
                onDrop={(acceptedFiles) => {
                  if (acceptedFiles.length > 0) {
                    const file = acceptedFiles[0];

                    setImg(file); // Store File object in state
                    formik.setFieldValue("banner_image", file); // Store File in Formik
                  }
                }}
                multiple={false} // Prevent multiple image selection
              >
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <p>Drag 'n' drop some files here, or click to select files</p>
                    </div>
                  </section>
                )}
              </Dropzone>
            </div>
            <div className="showimages d-flex flex-wrap gap-3 mt-3">
              {formik.values.banner_image && (
                <div className="position-relative">
                  <button
                    type="button"
                    onClick={() => {
                      setImg(""); // Clear image
                      formik.setFieldValue("banner_image", ""); // Reset Formik field
                    }}
                    className="position-absolute"
                    style={{
                      right: "5px", background: "transparent",
                      border: "none",
                      color: "white",
                      fontSize: "1.5rem",
                      fontWeight: "bold",
                    }}
                  >×</button>
                  {console.log("finaslllll", formik.values.banner_image)}

                  {typeof formik.values.banner_image === "string" ? (
                    <img
                      src={resolveMediaUrl(formik.values.banner_image)}
                      alt="Banner"
                      width={200}
                      height={200}
                    />
                  ) : (
                    <img
                      src={URL.createObjectURL(formik.values.banner_image)}
                      alt="Banner"
                      width={200}
                      height={200}
                    />
                  )}
                </div>
              )}
            </div>
          </div>

          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
          >
            {getbannerId !== undefined ? "Edit" : "Add"} Banner
          </button>

        </form>
      </div>
    </div>
  );
};

export default Addbanner;